<!DOCTYPE html>
<html lang="ru">

<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>SC2 FFA League</title>
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Zekton:wght@500;600;700&display=swap" rel="stylesheet">
    <style>
        html,
        body {
            background: #0a0c10;
            color: #e0e6ed;
            margin: 0;
            font-family: 'Zekton', 'Segoe UI', sans-serif;
            min-height: 100vh;
        }

        body {
            visibility: hidden;
        }

        body.is-ready {
            visibility: visible;
            animation: page-fade-in 0.25s ease-out;
        }

        #app-preloader {
            position: fixed;
            inset: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 24px;
            background: #0a0c10;
            z-index: 9999;
            transition: opacity 0.25s ease-out;
        }

        body.is-ready #app-preloader {
            opacity: 0;
            pointer-events: none;
        }

        .preloader-spinner {
            width: 56px;
            height: 56px;
            border-radius: 50%;
            border: 3px solid #1a2029;
            border-top-color: #3498db;
            border-right-color: #3498db;
            animation: preloader-spin 0.9s linear infinite;
            box-shadow: 0 0 24px rgba(52, 152, 219, 0.3);
        }

        .preloader-text {
            font-family: 'Zekton', 'Segoe UI', sans-serif;
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 4px;
            color: #556677;
            text-transform: uppercase;
            animation: preloader-pulse 1.4s ease-in-out infinite;
        }

        @keyframes preloader-spin {
            to {
                transform: rotate(360deg);
            }
        }

        @keyframes preloader-pulse {

            0%,
            100% {
                opacity: 0.5;
            }

            50% {
                opacity: 1;
            }
        }

        @keyframes page-fade-in {
            from {
                opacity: 0;
            }

            to {
                opacity: 1;
            }
        }
    </style>
</head>

<body>
    <div id="app-preloader">
        <div class="preloader-spinner"></div>
        <div class="preloader-text">ЗАГРУЗКА…</div>
    </div>

    <header class="topbar">
        <h1><a href="/" class="topbar-title-link">SC2 FFA LEAGUE</a></h1>
        <div class="topbar-right">
            <div class="lang-switch" id="lang-switch">
                <button type="button" class="lang-btn" data-lang="ru">RU</button>
                <button type="button" class="lang-btn" data-lang="en">EN</button>
            </div>
            <a href="/support" class="topbar-link topbar-support-link" data-i18n-title="support.button"
                title="Поддержать проект">
                <span class="topbar-support-icon">💛</span>
                <span class="topbar-support-label" data-i18n="support.topbar">Поддержать</span>
            </a>
            <div id="user-box" class="user-box"></div>
        </div>
    </header>

    <nav class="site-nav" id="site-nav">
        <a href="/" class="site-nav-link" data-nav="players">
            <span class="site-nav-icon">👥</span>
            <span data-i18n="nav.players">Игроки</span>
        </a>
        <a href="/games" class="site-nav-link" data-nav="games">
            <span class="site-nav-icon">⚔️</span>
            <span data-i18n="nav.games">Игры</span>
        </a>
        <a href="/maps" class="site-nav-link" data-nav="maps">
            <span class="site-nav-icon">🗺️</span>
            <span data-i18n="nav.maps">Карты</span>
        </a>
        <a href="/mods" class="site-nav-link" data-nav="mods">
            <span class="site-nav-icon">🧩</span>
            <span data-i18n="nav.mods">Моды</span>
        </a>
        <a href="/leaderboard" class="site-nav-link" data-nav="leaderboard">
            <span class="site-nav-icon">🏆</span>
            <span data-i18n="nav.leaderboard">Лидерборд</span>
        </a>
        <a href="/stats" class="site-nav-link" data-nav="stats">
            <span class="site-nav-icon">📊</span>
            <span data-i18n="nav.stats">Статистика</span>
        </a>
        <a href="/tools" class="site-nav-link" data-nav="tools">
            <span class="site-nav-icon">🛠️</span>
            <span data-i18n="nav.tools">Инструменты</span>
        </a>
    </nav>


    <main id="app">
        <!-- Плашка о поддержке (показывается на всех страницах) -->
        <div id="support-banner" class="support-banner hidden">
            <button type="button" class="support-banner-body" id="support-banner-open">
                <span class="support-banner-icon">💛</span>
                <span class="support-banner-text" data-i18n="support.banner_text">Сайт некоммерческий, а времена тяжёлые — хостинг дорожает. Если можете, поддержите проект 🙏</span>
                <span class="support-banner-cta" data-i18n="support.banner_cta">Поддержать</span>
            </button>
            <button type="button" class="support-banner-close" id="support-banner-close"
                data-i18n-aria-label="support.banner_dismiss" aria-label="Скрыть">✕</button>
        </div>

        <!-- Плашка «сейчас в эфире» (показывается, когда есть live-стримы) -->
        <div id="streams-banner" class="streams-banner hidden">
            <span class="streams-banner-icon" aria-hidden="true"></span>
            <span class="streams-banner-label" data-i18n="streams.banner_label">Сейчас в эфире:</span>
            <div id="streams-banner-list" class="streams-banner-list"></div>
            <button type="button" class="streams-banner-close" id="streams-banner-close"
                data-i18n-aria-label="streams.banner_close" aria-label="Скрыть">✕</button>
        </div>

        <!-- ============================================ -->
        <!-- Секция: авторизация -->
        <!-- ============================================ -->
        <section id="screen-auth" class="screen hidden">
            <div class="card" id="card-login">
                <h2 data-i18n="auth.login_title">Вход</h2>
                <p class="error hidden" id="auth-notice"></p>
                <form id="form-login" class="form">
                    <input type="text" name="identifier" data-i18n-placeholder="auth.identifier_placeholder"
                        placeholder="Email или никнейм" required autocomplete="username" />
                    <input type="password" name="password" data-i18n-placeholder="auth.password_placeholder"
                        placeholder="Пароль" required minlength="6" autocomplete="current-password" />
                    <button type="submit" data-i18n="common.login">Войти</button>
                </form>
                <p class="hint">
                    <a href="#" id="link-to-forgot" data-i18n="auth.forgot_link">Забыли пароль?</a>
                </p>
                <p class="hint">
                    <span data-i18n="auth.no_account">Нет аккаунта?</span>
                    <a href="#" id="link-to-signup" data-i18n="auth.signup_link">Зарегистрироваться</a>
                </p>
            </div>

            <div class="card hidden" id="card-forgot">
                <h2 data-i18n="auth.forgot_title">Сброс пароля</h2>
                <p class="hint" data-i18n="auth.forgot_hint">
                    Укажите email или никнейм — мы отправим ссылку для смены пароля.</p>
                <form id="form-forgot" class="form">
                    <input type="text" name="identifier" data-i18n-placeholder="auth.identifier_placeholder"
                        placeholder="Email или никнейм" required autocomplete="username" />
                    <button type="submit" data-i18n="auth.forgot_button">Отправить ссылку</button>
                </form>
                <p class="hint">
                    <a href="#" id="link-forgot-to-login" data-i18n="auth.login_link">Войти</a>
                </p>
            </div>

            <div class="card hidden" id="card-signup">
                <h2 data-i18n="auth.signup_title">Регистрация</h2>
                <div class="signup-body">
                    <form id="form-signup" class="form">
                        <input type="text" name="username" data-i18n-placeholder="auth.username_placeholder"
                            placeholder="Никнейм (3-32 символа)" required minlength="3" maxlength="32"
                            pattern="[a-zA-Z0-9_.\-]+" />
                        <input type="email" name="email" data-i18n-placeholder="auth.email_placeholder" placeholder="Email"
                            required />
                        <div class="password-field">
                            <input type="password" name="password" data-i18n-placeholder="auth.password_placeholder_signup"
                                placeholder="Пароль (мин. 6)" required minlength="6" />
                            <button type="button" class="password-toggle" data-i18n-title="auth.show_password"
                                title="Показать пароль" aria-label="Показать пароль">👁</button>
                        </div>
                        <div id="captcha-container" class="captcha-container"></div>
                        <button type="submit" data-i18n="auth.signup_title">Создать аккаунт</button>
                    </form>
                    <aside class="email-note">
                        <p class="email-note-title" data-i18n="auth.email_note_title">Совет по почте</p>
                        <p class="email-note-text" data-i18n="auth.email_note_text">Письма для подтверждения могут не
                            доходить на российские почтовые сервисы. Рекомендуем зарубежную почту — например, Gmail.</p>
                    </aside>
                </div>
                <p class="hint">
                    <span data-i18n="auth.have_account">Уже есть аккаунт?</span>
                    <a href="#" id="link-to-login" data-i18n="auth.login_link">Войти</a>
                </p>
            </div>

            <div class="card hidden" id="card-reset">
                <h2 data-i18n="auth.reset_title">Новый пароль</h2>
                <form id="form-reset" class="form">
                    <input type="password" name="password" data-i18n-placeholder="auth.password_placeholder_signup"
                        placeholder="Пароль (мин. 6)" required minlength="6" autocomplete="new-password" />
                    <input type="password" name="password2" data-i18n-placeholder="auth.password_repeat_placeholder"
                        placeholder="Повторите пароль" required minlength="6" autocomplete="new-password" />
                    <button type="submit" data-i18n="auth.reset_button">Сохранить пароль</button>
                </form>
                <p class="hint hidden" id="reset-error" data-i18n="auth.reset_invalid">Ссылка недействительна или устарела.</p>
                <p class="hint">
                    <a href="#" id="link-reset-to-login" data-i18n="auth.login_link">Войти</a>
                </p>
            </div>
        </section>

        <!-- ============================================ -->
        <!-- Секция: список игроков -->
        <!-- ============================================ -->
        <section id="screen-players" class="screen hidden">
            <div class="toolbar">
                <h2 data-i18n="players.title">Игроки</h2>
                <div class="toolbar-actions">
                    <input type="text" id="players-search" class="players-search"
                        data-i18n-placeholder="players.search_placeholder" placeholder="Поиск по имени или aka…" />
                    <div class="view-toggle" id="view-toggle">
                        <button type="button" class="view-toggle-btn is-active" data-view="table">
                            ☰ <span data-i18n="players.view_table">Таблица</span>
                        </button>
                        <button type="button" class="view-toggle-btn" data-view="wall">
                            ◆ <span data-i18n="players.view_cards">Карточки</span>
                        </button>
                        <button type="button" class="view-toggle-btn" data-view="tierlist">
                            ◈ <span data-i18n="players.view_tierlist">Тирлист</span>
                        </button>
                    </div>
                    <form id="form-create-player" class="inline-form">
                        <input type="text" name="name" data-i18n-placeholder="players.add_placeholder"
                            placeholder="Имя нового игрока" required maxlength="100" />
                        <button type="submit" data-i18n="players.add_button">Добавить</button>
                    </form>
                </div>
            </div>

            <div id="players-error" class="error hidden"></div>

            <div class="players-layout">
              <div class="players-main">
                <div id="players-table-view" class="players-table-wrap">
                    <table class="players-table">
                    <thead>
                        <tr>
                            <th data-sort-key="tier" data-i18n="ratings.col.tier" class="tier-col-th">Тир</th>
                            <th data-sort-key="name" data-i18n="players.col.name">Игрок</th>
                            <!-- <th data-sort-key="elo" data-i18n="players.col.elo">MMR</th> -->
                            <th data-sort-key="races" data-i18n="players.col.races" class="col-mobile-hide">Расы</th>
                            <th class="col-desktop" data-sort-key="activity" data-i18n="players.col.activity">Активность</th>
                            <th class="col-desktop" data-sort-key="adaptiveness" data-i18n="stat.adaptiveness">
                                Адаптивность</th>
                            <th class="col-desktop" data-sort-key="aggression" data-i18n="stat.aggression">Агрессия</th>
                            <th class="col-desktop" data-sort-key="turtle" data-i18n="stat.turtle">Черепашность</th>
                            <th class="col-desktop" data-sort-key="variety" data-i18n="stat.variety">Разнообразие</th>
                            <th class="col-desktop" data-sort-key="survival" data-i18n="stat.survival">Выживание</th>
                            <th class="col-desktop" data-sort-key="greed" data-i18n="stat.greed">Халява</th>
                            <!-- <th data-sort-key="total" data-i18n="players.col.total" class="total-col col-mobile-hide">Итого</th>
                            <th class="players-actions-header"></th> -->
                        </tr>
                    </thead>
                    <tbody id="players-tbody"></tbody>
                </table>
            </div>

            <div id="players-wall-view" class="hidden">
                <div class="wall-sort" id="players-wall-sort">
                    <label class="wall-sort-label" for="players-sort-key" data-i18n="players.sort_by">Сортировка</label>
                    <select id="players-sort-key" class="wall-sort-select"></select>
                    <button type="button" id="players-sort-dir" class="wall-sort-dir">▲</button>
                </div>
                <div id="players-wall" class="players-wall"></div>
            </div>

            <div id="players-tierlist-view" class="hidden"></div>
              </div>

              <aside id="players-hall" class="players-hall"></aside>
            </div>
        </section>

        <!-- ============================================ -->
        <!-- Секция: карточка игрока -->
        <!-- ============================================ -->
        <section id="screen-player" class="screen hidden">
            <button id="btn-back" class="btn-secondary" data-i18n="player.back">← Назад</button>

            <div id="player-mode-toggle" class="player-mode-toggle"></div>

            <div class="player-stage" id="player-stage">
                <div class="player-card-pane" id="player-card-pane"></div>
                <aside class="player-edit-pane" id="player-edit-pane">
                    <div id="rating-form-container"></div>
                </aside>
            </div>

            <!-- Отношение к игроку: крупные реакции прямо под карточкой, до кнопок -->
            <div id="player-reactions-container" class="player-reactions-pane"></div>

            <div class="player-actions" id="player-actions"></div>

            <!-- Типаж: отдельная панель под кнопками оценок (не сдвигается с редактором) -->
            <div id="player-archetype-container" class="player-archetype-pane"></div>

            <!-- «Ссылки»: Twitch-каналы, привязанные к игроку в админке -->
            <div id="player-links-container" class="player-links-pane"></div>

            <!-- <div id="player-description-container" class="player-description-pane"></div> -->

            <div id="player-host-container" class="player-host-pane"></div>

            <div id="player-games-container" class="player-games-pane"></div>

            <div id="ratings-list-container" class="player-ratings-pane"></div>

            <div id="given-ratings-container" class="player-ratings-pane"></div>
        </section>

        <!-- ============================================ -->
        <!-- Секция: игры -->
        <!-- ============================================ -->
        <section id="screen-games" class="screen hidden">
            <!-- Большая зона приёма реплея: файл можно бросить в любое место раздела -->
            <div id="games-replay-dropzone" class="replay-dropzone hidden">
                <div class="replay-dropzone-box">
                    <div class="replay-dropzone-icon" aria-hidden="true">🎬</div>
                    <div class="replay-dropzone-title" data-i18n="games.replay_dropzone">Отпустите файл реплея</div>
                    <div class="replay-dropzone-title replay-dropzone-parsing"
                        data-i18n="games.replay_parsing">Разбор реплея…</div>
                    <div class="replay-dropzone-hint" data-i18n="games.replay_dropzone_hint">Форма игры
                        заполнится автоматически (.SC2Replay)</div>
                </div>
            </div>
            <div class="toolbar">
                <h2 data-i18n="games.title">Игры</h2>
                <div class="toolbar-actions">
                    <input type="text" id="games-search" class="players-search"
                        data-i18n-placeholder="games.search_placeholder" placeholder="Поиск по игроку…" />
                    <button type="button" id="btn-create-game" class="btn-primary" data-i18n="games.add_button" hidden>+
                        Добавить игру</button>
                    <button type="button" id="btn-add-from-replay" class="btn-secondary"
                        data-i18n="games.from_replay" data-i18n-title="games.replay_drop_hint" hidden>Из реплея</button>
                    <button type="button" id="btn-games-replays" class="btn-secondary"
                        data-i18n="games.replays_button" hidden>Папка реплеев</button>
                    <input type="file" id="replay-file-input" accept=".SC2Replay,.sc2replay,.replay" hidden />
                    <input type="file" id="games-replay-folder" accept=".SC2Replay,.sc2replay,.replay"
                        webkitdirectory multiple hidden />
                </div>
            </div>

            <!-- Панель фильтров -->
            <div class="games-filters" id="games-filters">
                <div class="games-filter">
                    <label class="games-filter-label" data-i18n="games.filter_format">Формат</label>
                    <select id="filter-format" class="games-filter-select">
                        <option value="" data-i18n="games.filter_all">Все</option>
                    </select>
                </div>
                <div class="games-filter">
                    <label class="games-filter-label" data-i18n="games.filter_host">Проводящий</label>
                    <select id="filter-host" class="games-filter-select">
                        <option value="" data-i18n="games.filter_all">Все</option>
                    </select>
                </div>
                <div class="games-filter">
                    <label class="games-filter-label" data-i18n="games.filter_map">Карта</label>
                    <select id="filter-map" class="games-filter-select">
                        <option value="" data-i18n="games.filter_all">Все</option>
                    </select>
                </div>
                <div class="games-filter-reset-wrap">
                    <button type="button" id="btn-reset-filters" class="btn-secondary" hidden
                        data-i18n="games.filter_reset">Сбросить</button>
                </div>
            </div>

            <!-- Активные фильтры -->
            <div class="games-active-filters" id="games-active-filters"></div>

            <div id="games-error" class="error hidden"></div>

            <div id="games-replays-panel" class="games-replays hidden"></div>

            <!-- «Новые игры с прошлого визита» + аккуратный намёк оценить их -->
            <div id="games-new-banner" class="games-new-banner hidden"></div>

            <div id="games-list-container">
                <div class="skeleton skeleton-block"></div>
            </div>

            <!-- Сентинел подгрузки более ранних игр (инфинити-скролл + кнопка) -->
            <div id="games-load-more" class="games-load-more hidden">
                <button type="button" id="btn-load-more" class="btn-secondary"
                    data-i18n="games.load_more">Показать более ранние игры</button>
            </div>
        </section>

        <!-- ============================================ -->
        <!-- Секция: управление оверлеем -->
        <!-- ============================================ -->
        <section id="screen-control" class="screen hidden">
            <div class="control-main">
                <section class="control-section control-overlay-panel">
                    <h2 data-i18n="control.obs_panel_title">OBS BROWSER SOURCE</h2>
                    <p class="control-overlay-hint" data-i18n="control.obs_hint">
                        Скопируйте ссылку ниже и вставьте её в OBS как Browser Source.
                    </p>
                    <div class="control-overlay-url">
                        <input type="text" id="overlay-url" class="control-input control-overlay-input" readonly
                            value="" />
                        <button type="button" id="btn-copy-url" class="control-copy-btn"
                            data-i18n-title="control.copy_url">
                            <span class="control-copy-icon">⧉</span>
                            <span class="control-copy-label" data-i18n="control.copy_url">Копировать</span>
                        </button>
                        <a id="btn-open-overlay" href="/overlay" target="_blank" rel="noopener noreferrer"
                            class="control-open-btn" data-i18n-title="control.open_overlay">
                            <span class="control-open-icon">↗</span>
                            <span class="control-open-label" data-i18n="control.open_overlay">Открыть</span>
                        </a>
                        <button type="button" id="btn-regenerate-token" class="control-regen-btn">
                            <span class="control-regen-icon">↻</span>
                            <span class="control-regen-label" data-i18n="control.regenerate_token">Перевыпустить</span>
                        </button>
                    </div>
                    <!-- Связь с сервером и число реально подключённых источников OBS -->
                    <div class="control-obs-state">
                        <span class="control-status" id="control-status">…</span>
                        <span class="control-overlay-sources" id="control-overlay-sources"></span>
                    </div>
                    <div class="control-overlay-warning hidden" id="control-overlay-warning">
                        <strong data-i18n="control.overlay_off">Оверлей не подключён</strong>
                        <p class="hint" data-i18n="control.overlay_off_hint">Источник в OBS не подключён к серверу.</p>
                    </div>
                </section>

                <section class="control-section">
                    <h2 data-i18n="control.preview_title">ПРЕВЬЮ КАРТОЧКИ</h2>
                    <div id="control-preview" class="control-preview"></div>
                </section>

                <section class="control-section">
                    <h2 data-i18n="control.players_title">ИГРОКИ</h2>
                    <input type="text" id="control-search" class="control-search"
                        data-i18n-placeholder="control.players_search" placeholder="Поиск игрока…" autocomplete="off" />
                    <!-- Режим закрепления: кнопки 📌 у игроков показываются только при включении -->
                    <label class="control-label control-label--inline control-pin-mode"
                        data-i18n-title="control.pin_mode_hint">
                        <input type="checkbox" id="control-pin-mode" />
                        <span data-i18n="control.pin_mode_label">Режим закрепления</span>
                    </label>
                    <div id="control-players" class="control-players"></div>
                </section>

                <section class="control-section">
                    <h2 data-i18n="control.show_title">ПОКАЗ</h2>
                    <div class="control-actions">
                        <button type="button" id="btn-hide" class="btn-danger" data-i18n="control.hide_button">Скрыть
                            карточку</button>
                    </div>
                    <div class="control-current" id="control-current" data-i18n="control.current_nothing">Ничего не
                        показывается</div>
                    <!-- Виджет инструментов сайта (рандомизатор и т.п.) на оверлее -->
                    <div class="control-widget hidden" id="control-widget">
                        <div class="control-widget-text" id="control-widget-text"></div>
                        <button type="button" id="btn-hide-widget" class="btn-danger"
                            data-i18n="control.hide_widget">Скрыть виджет</button>
                    </div>
                </section>

                <section class="control-section">
                    <h2 data-i18n="control.settings_title">НАСТРОЙКИ</h2>
                    <label class="control-label">
                        <span data-i18n="control.view_mode_label">Режим показа</span>
                        <select id="setting-view-mode" class="control-select">
                            <option value="average" data-i18n="control.view_mode_average">Средние оценки</option>
                            <option value="personal" data-i18n="control.view_mode_personal">Мои оценки</option>
                            <option value="ghost" data-i18n="control.view_mode_ghost">Оценки GHOST</option>
                        </select>
                    </label>
                    <label class="control-label">
                        <span data-i18n="control.animation_label">Анимация появления</span>
                        <select id="setting-animation" class="control-select">
                            <option value="fade" data-i18n="control.animation_fade">Fade</option>
                            <option value="slide-left" data-i18n="control.animation_slide_left">Вылет слева</option>
                            <option value="slide-right" data-i18n="control.animation_slide_right">Вылет справа</option>
                            <option value="slide-up" data-i18n="control.animation_slide_up">Вылет снизу</option>
                            <option value="slide-down" data-i18n="control.animation_slide_down">Вылет сверху</option>
                            <option value="none" data-i18n="control.animation_none">Без анимации</option>
                        </select>
                    </label>
                    <label class="control-label control-label--inline">
                        <input type="checkbox" id="setting-autohide" />
                        <span data-i18n="control.autohide_label">Автоматически скрывать</span>
                    </label>
                    <label class="control-label">
                        <span data-i18n="control.autohide_delay_label">Скрывать через (секунд)</span>
                        <input type="number" id="setting-delay" class="control-input" min="1" max="600" value="7" />
                    </label>
                </section>
            </div>
        </section>

        <!-- ============================================ -->
        <!-- Секция: админ-панель -->
        <!-- ============================================ -->
        <section id="screen-admin" class="screen hidden">
            <div class="admin-main">
                <section class="admin-section">
                    <div class="admin-section-header">
                        <h2 data-i18n="admin.users_title">Пользователи</h2>
                        <input type="text" id="admin-search" class="admin-search"
                            data-i18n-placeholder="admin.users_search" placeholder="Поиск по email или нику…"
                            autocomplete="off" />
                    </div>
                    <div id="admin-users" class="admin-users">
                        <div class="skeleton skeleton-block"></div>
                    </div>
                </section>

                <section class="admin-section">
                    <div class="admin-section-header">
                        <h2 data-i18n="admin.players_title">Игроки</h2>
                        <input type="text" id="admin-players-search" class="admin-search"
                            data-i18n-placeholder="admin.players_search" placeholder="Поиск по имени или aka…"
                            autocomplete="off" />
                    </div>
                    <p class="hint" data-i18n="admin.players_hint">Удаление игрока каскадно удалит все его оценки.</p>
                    <div id="admin-players" class="admin-players">
                        <div class="skeleton skeleton-block"></div>
                    </div>
                </section>

                <section class="admin-section">
                    <div class="admin-section-header">
                        <h2 data-i18n="admin.formats_title">Форматы игр</h2>
                        <button type="button" id="btn-add-formats" class="btn-primary" data-i18n="admin.add_format">
                            + Добавить формат
                        </button>
                    </div>
                    <div id="admin-formats" class="admin-refs-list">
                        <div class="skeleton skeleton-block"></div>
                    </div>
                </section>

                <section class="admin-section">
                    <div class="admin-section-header">
                        <h2 data-i18n="admin.hosts_title">Ведущие</h2>
                        <button type="button" id="btn-add-hosts" class="btn-primary" data-i18n="admin.add_host">
                            + Добавить ведущего
                        </button>
                    </div>
                    <div id="admin-hosts" class="admin-refs-list">
                        <div class="skeleton skeleton-block"></div>
                    </div>
                </section>

                <section class="admin-section">
                    <div class="admin-section-header">
                        <h2 data-i18n="admin.maps_title">Карты</h2>
                        <input type="text" id="admin-maps-search" class="admin-search"
                            data-i18n-placeholder="admin.maps_search" placeholder="Поиск по названию…"
                            autocomplete="off" />
                        <button type="button" id="btn-add-maps" class="btn-primary" data-i18n="admin.add_map">
                            + Добавить карту
                        </button>
                    </div>
                    <div id="admin-maps" class="admin-refs-list"></div>
                </section>

                <section class="admin-section">
                    <div class="admin-section-header">
                        <h2 data-i18n="admin.mods_title">Моды</h2>
                        <input type="text" id="admin-mods-search" class="admin-search"
                            data-i18n-placeholder="admin.mods_search" placeholder="Поиск по названию…"
                            autocomplete="off" />
                        <button type="button" id="btn-add-mods" class="btn-primary" data-i18n="admin.add_mod">
                            + Добавить мод
                        </button>
                    </div>
                    <div id="admin-mods" class="admin-refs-list"></div>
                </section>

                <section class="admin-section">
                    <div class="admin-section-header">
                        <h2 data-i18n="admin.titles_title">Титулы</h2>
                        <button type="button" id="btn-add-title" class="btn-primary" data-i18n="admin.add_title">
                            + Добавить титул
                        </button>
                    </div>
                    <p class="hint" data-i18n="admin.titles_hint">Титул показывается в карточке игрока справа сверху и в оверлее.</p>
                    <div id="admin-titles" class="admin-titles"></div>
                </section>

                <section class="admin-section">
                    <div class="admin-section-header">
                        <h2 data-i18n="admin.streamers_title">Стримеры</h2>
                        <button type="button" id="btn-add-streamer" class="btn-primary" data-i18n="admin.add_streamer">
                            + Добавить стримера
                        </button>
                    </div>
                    <p class="hint" data-i18n="admin.streamers_hint">Ссылки на Twitch-каналы стримеров FFA. Сайт сам проверяет, кто сейчас в эфире, и показывает плашку сверху страницы.</p>
                    <div id="admin-streamers" class="admin-refs-list"></div>
                </section>

                <section class="admin-section">
                    <div class="admin-section-header">
                        <h2 data-i18n="admin.donations_title">Донаты</h2>
                    </div>
                    <p class="hint" data-i18n="admin.donations_hint">Полученные донаты. Показываются списком внизу страницы «Поддержать проект».</p>
                    <div class="admin-donation-form">
                        <input type="text" id="donation-name" class="admin-search"
                            data-i18n-placeholder="admin.donation_name_placeholder" placeholder="Имя" autocomplete="off" />
                        <input type="number" id="donation-amount" class="admin-search admin-donation-amount"
                            min="0" step="0.01" data-i18n-placeholder="admin.donation_amount_placeholder" placeholder="Сумма" />
                        <select id="donation-currency" class="admin-search admin-donation-currency">
                            <option value="RUB">₽ RUB</option>
                            <option value="USD">$ USD</option>
                            <option value="EUR">€ EUR</option>
                        </select>
                        <input type="date" id="donation-date" class="admin-search" />
                        <input type="text" id="donation-message" class="admin-search admin-donation-message"
                            data-i18n-placeholder="admin.donation_message_placeholder" placeholder="Сообщение (необязательно)"
                            autocomplete="off" />
                        <button type="button" id="btn-add-donation" class="btn-primary" data-i18n="admin.add_donation">+ Добавить донат</button>
                    </div>
                    <div id="admin-donations" class="admin-refs-list"></div>
                </section>

                <section class="admin-section">
                    <div class="admin-section-header">
                        <h2 data-i18n="admin.logs_title">Лог действий</h2>
                        <div class="admin-logs-controls">
                            <select id="admin-logs-action" class="admin-logs-select">
                                <option value="" data-i18n="admin.logs_filter_all">Все действия</option>
                            </select>
                            <input type="text" id="admin-logs-search" class="admin-search"
                                data-i18n-placeholder="admin.logs_search" placeholder="Поиск по логу…"
                                autocomplete="off" />
                            <button type="button" id="btn-admin-logs-refresh" class="btn-secondary"
                                data-i18n="admin.logs_refresh">Обновить</button>
                        </div>
                    </div>
                    <div id="admin-logs" class="admin-logs">
                        <div class="skeleton skeleton-block"></div>
                    </div>
                </section>

                <section class="admin-section">
                    <div class="admin-section-header">
                        <h2 data-i18n="admin.visits_title">Посещения сайта</h2>
                        <div class="admin-logs-controls">
                            <select id="admin-visits-days" class="admin-logs-select">
                                <option value="7" data-i18n="admin.visits_days_7">7 дней</option>
                                <option value="30" selected data-i18n="admin.visits_days_30">30 дней</option>
                                <option value="90" data-i18n="admin.visits_days_90">90 дней</option>
                            </select>
                            <button type="button" id="btn-admin-visits-stats-refresh" class="btn-secondary"
                                data-i18n="admin.logs_refresh">Обновить</button>
                        </div>
                    </div>
                    <p class="hint" data-i18n="admin.visits_hint">Просмотры страниц собираются автоматически при переходах по сайту. Боты, админка и страница управления оверлеем не учитываются.</p>
                    <div id="admin-visits-stats" class="admin-visits-stats">
                        <div class="skeleton skeleton-block"></div>
                    </div>

                    <div class="admin-section-header admin-visits-log-header">
                        <h3 data-i18n="admin.visits_log_title">Лог посещений</h3>
                        <div class="admin-logs-controls">
                            <input type="text" id="admin-visits-search" class="admin-search"
                                data-i18n-placeholder="admin.visits_search" placeholder="Поиск по странице, referrer или UA…"
                                autocomplete="off" />
                            <button type="button" id="btn-admin-visits-refresh" class="btn-secondary"
                                data-i18n="admin.logs_refresh">Обновить</button>
                        </div>
                    </div>
                    <div id="admin-visits-log" class="admin-logs admin-visits-log">
                        <div class="skeleton skeleton-block"></div>
                    </div>
                </section>

                <section class="admin-section">
                    <div class="admin-section-header">
                        <h2 data-i18n="admin.archive_title">Архив удалённых оценок</h2>
                        <div class="admin-logs-controls">
                            <input type="text" id="admin-archive-search" class="admin-search"
                                data-i18n-placeholder="admin.archive_search" placeholder="Поиск по игроку или пользователю…"
                                autocomplete="off" />
                            <button type="button" id="btn-admin-archive-refresh" class="btn-secondary"
                                data-i18n="admin.logs_refresh">Обновить</button>
                        </div>
                    </div>
                    <div id="admin-ratings-archive" class="admin-archive">
                        <div class="skeleton skeleton-block"></div>
                    </div>
                </section>

                <section class="admin-section">
                    <div class="admin-section-header">
                        <h2 data-i18n="admin.trash_title">Удалённые игры и моды</h2>
                        <div class="admin-logs-controls">
                            <button type="button" id="btn-admin-trash-refresh" class="btn-secondary"
                                data-i18n="admin.logs_refresh">Обновить</button>
                        </div>
                    </div>
                    <p class="hint" data-i18n="admin.trash_hint">Перед удалением сюда сохраняется копия игры или мода. «Восстановить» возвращает её на сайт (с новым номером).</p>
                    <div id="admin-trash" class="admin-archive">
                        <div class="skeleton skeleton-block"></div>
                    </div>
                </section>
            </div>
        </section>

        <section id="screen-leaderboard" class="screen hidden">
            <div class="toolbar">
                <h2 data-i18n="leaderboard.title">Лидерборд</h2>
            </div>
            <div id="leaderboard-container">
                <div class="skeleton skeleton-block"></div>
            </div>
        </section>

        <!-- ============================================ -->
        <!-- Секция: статистика по расам -->
        <!-- ============================================ -->
        <section id="screen-statistics" class="screen hidden">
            <div class="toolbar">
                <h2 data-i18n="statistics.title">Статистика</h2>
            </div>
            <div id="statistics-container">
                <div class="skeleton skeleton-block"></div>
            </div>
        </section>

        <!-- ============================================ -->
        <!-- Секция: карты (публичный список) -->
        <!-- ============================================ -->
        <section id="screen-maps" class="screen hidden">
            <div class="toolbar">
                <h2 data-i18n="maps.title">Карты</h2>
                <div class="toolbar-actions">
                    <button type="button" id="btn-maps-add" class="btn-primary" data-i18n="maps.add_button"
                        hidden>+ Добавить карту</button>
                </div>
            </div>
            <div id="maps-container"></div>
        </section>

        <!-- ============================================ -->
        <!-- Секция: моды (публичный список) -->
        <!-- ============================================ -->
        <section id="screen-mods" class="screen hidden">
            <div class="toolbar">
                <h2 data-i18n="mods.title">Моды</h2>
                <div class="toolbar-actions">
                    <button type="button" id="btn-mods-add" class="btn-primary" data-i18n="mods.add_button"
                        hidden>+ Добавить мод</button>
                </div>
            </div>
            <div id="mods-container"></div>
        </section>

        <!-- ============================================ -->
        <!-- Секция: инструменты (хаб) -->
        <!-- ============================================ -->
        <section id="screen-tools" class="screen hidden">
            <div class="tools-hero">
                <div class="tools-hero-eyebrow" data-i18n="tools.hero_eyebrow">FFA League · Арсенал</div>
                <h2 data-i18n="tools.title">Инструменты</h2>
                <p class="tools-hero-desc" data-i18n="tools.hero_desc">
                    Всё для подготовки и показа матча: розыгрыш карты и мода, прогноз победителя, сценарий
                    встречи и оверлей для стрима.
                </p>
            </div>
            <div class="tools-list" id="tools-list"></div>
        </section>

        <!-- ============================================ -->
        <!-- Секция: прогноз победителя -->
        <!-- ============================================ -->
        <section id="screen-predict" class="screen hidden">
            <button id="btn-back-tools" class="btn-secondary" data-i18n="player.back">← Назад</button>

            <div class="toolbar">
                <h2 data-i18n="tools.predict_title">Прогноз победителя</h2>
            </div>
            <p class="tool-lead" data-i18n="tools.predict_desc">
                Укажите участников, при желании карту и мод — покажем предполагаемые места и шанс на победу с
                учётом истории игр.</p>

            <div class="predict-layout">
                <div class="card predict-form-card">
                    <div class="form-section">
                        <div class="form-section-header">
                            <span data-i18n="tools.predict_players">Игроки</span>
                            <button type="button" id="btn-predict-add-player" class="btn-secondary"
                                data-i18n="games.add_player">+ Добавить игрока</button>
                        </div>
                        <div id="predict-players" class="predict-players"></div>
                    </div>

                    <div class="form-row">
                        <label class="form-field">
                            <span data-i18n="games.field_map">Карта</span>
                            <select id="predict-map" class="games-filter-select"></select>
                        </label>
                        <label class="form-field">
                            <span data-i18n="games.field_mod">Мод</span>
                            <select id="predict-mod" class="games-filter-select"></select>
                        </label>
                    </div>

                    <div class="form-actions">
                        <button type="button" id="btn-predict-reset" class="btn-secondary"
                            data-i18n="tools.reset">Сбросить</button>
                        <button type="button" id="btn-predict-run" class="btn-primary"
                            data-i18n="tools.predict_run">Рассчитать</button>
                    </div>

                    <div id="predict-error" class="error hidden"></div>
                </div>

                <div id="predict-results" class="card predict-results">
                    <div class="predict-results-head">
                        <h3 data-i18n="tools.predict_results">Результат</h3>
                        <button type="button" id="btn-predict-random" class="btn-secondary predict-random-btn"
                            data-i18n-title="tools.predict_random_hint">
                            <span class="predict-random-dice">🎲</span>
                            <span data-i18n="tools.predict_random">Случайный победитель</span>
                        </button>
                    </div>
                    <div id="predict-random-winner" class="predict-random-winner hidden"></div>
                    <div id="predict-results-body"></div>
                </div>
            </div>
        </section>

        <!-- ============================================ -->
        <!-- Секция: выбор карты и режима (рандомайзер) -->
        <!-- ============================================ -->
        <section id="screen-random" class="screen hidden">
            <button id="btn-back-tools-random" class="btn-secondary" data-i18n="player.back">← Назад</button>

            <div class="toolbar">
                <h2 data-i18n="tools.random_title">Выбор карты и режима</h2>
            </div>
            <p class="tool-lead" data-i18n="tools.random_desc">
                Случайная карта и мод для следующей игры. Лишние можно исключить — выбор сохранится в браузере.</p>

            <div id="random-root" class="rr-root"></div>
        </section>

        <!-- ============================================ -->
        <!-- Секция: менеджер матча -->
        <!-- ============================================ -->
        <section id="screen-match" class="screen hidden">
            <!-- Зона приёма реплея: файл можно бросить в любое место страницы -->
            <div id="match-replay-dropzone" class="replay-dropzone hidden">
                <div class="replay-dropzone-box">
                    <div class="replay-dropzone-icon" aria-hidden="true">🎬</div>
                    <div class="replay-dropzone-title" data-i18n="games.replay_dropzone">Отпустите файл
                        реплея</div>
                    <div class="replay-dropzone-title replay-dropzone-parsing"
                        data-i18n="games.replay_parsing">Разбор реплея…</div>
                    <div class="replay-dropzone-hint" data-i18n="tools.match_replay_drop_hint">
                        Участники, карта и дата заполнятся автоматически (.SC2Replay)</div>
                </div>
            </div>
            <div class="match-topbar">
                <button id="btn-back-tools-match" class="btn-secondary" data-i18n="player.back">← Назад</button>
                <button id="btn-reset-match" class="btn-secondary" data-i18n="tools.match_reset">⟲ Сбросить</button>
            </div>

            <div class="toolbar">
                <h2 data-i18n="tools.match_title">Менеджер матча</h2>
            </div>
            <p class="tool-lead" data-i18n="tools.match_desc">
                Интерактивный сценарий матча: разыграть карту и мод, собрать участников, посчитать прогноз,
                запустить режим стримера с закреплёнными игроками и добавить игру в список.</p>

            <div id="match-root" class="match-root"></div>
        </section>

        <!-- ============================================ -->
        <!-- Секция: личный профиль -->
        <!-- ============================================ -->
        <section id="screen-profile" class="screen hidden">
            <button id="btn-back-profile" class="btn-secondary" data-i18n="player.back">← Назад</button>

            <div class="toolbar">
                <h2 data-i18n="profile.title">Личный профиль</h2>
                <div class="toolbar-actions">
                    <button type="button" id="btn-profile-logout" class="btn-secondary"
                        data-i18n="common.logout">Выйти</button>
                </div>
            </div>

            <div class="profile-page">
                <div class="profile-columns">
                    <div class="card profile-card">
                        <h3 data-i18n="profile.username_title">Имя профиля</h3>
                        <p class="hint" data-i18n="profile.username_hint">
                            Ник показывается в шапке сайта и в списке оценок.</p>
                        <form id="form-profile-username" class="form">
                            <input type="text" id="profile-username" name="username"
                                data-i18n-placeholder="profile.username_placeholder"
                                placeholder="Ник (3-32 символа)" required minlength="3" maxlength="32"
                                pattern="[a-zA-Z0-9_.\-]+" autocomplete="username" />
                            <div class="profile-form-actions">
                                <button type="submit" class="btn-primary" data-i18n="profile.save">Сохранить</button>
                                <span class="profile-status hidden" id="profile-username-status"></span>
                            </div>
                        </form>
                    </div>

                    <div class="card profile-card">
                        <h3 data-i18n="profile.email_title">Почта</h3>
                        <p class="hint" data-i18n="profile.email_hint">
                            На эту почту приходят письма сайта. Смена подтверждается текущим паролем.</p>
                        <form id="form-profile-email" class="form">
                            <input type="email" id="profile-email" name="email"
                                data-i18n-placeholder="profile.email_placeholder" placeholder="Email"
                                required autocomplete="email" />
                            <div class="password-field">
                                <input type="password" name="current_password"
                                    data-i18n-placeholder="profile.current_password_placeholder"
                                    placeholder="Текущий пароль" required autocomplete="current-password" />
                                <button type="button" class="password-toggle" data-i18n-title="auth.show_password"
                                    title="Показать пароль" aria-label="Показать пароль">👁</button>
                            </div>
                            <div class="profile-form-actions">
                                <button type="submit" class="btn-primary" data-i18n="profile.save">Сохранить</button>
                                <span class="profile-status hidden" id="profile-email-status"></span>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="card profile-card">
                    <h3 data-i18n="profile.password_title">Пароль</h3>
                    <p class="hint" data-i18n="profile.password_hint">
                        Минимум 6 символов. После смены пароля старый перестанет работать.</p>
                    <form id="form-profile-password" class="form profile-password-form">
                        <div class="password-field">
                            <input type="password" name="current_password"
                                data-i18n-placeholder="profile.current_password_placeholder"
                                placeholder="Текущий пароль" required autocomplete="current-password" />
                            <button type="button" class="password-toggle" data-i18n-title="auth.show_password"
                                title="Показать пароль" aria-label="Показать пароль">👁</button>
                        </div>
                        <div class="password-field">
                            <input type="password" name="password"
                                data-i18n-placeholder="profile.new_password_placeholder"
                                placeholder="Новый пароль (мин. 6)" required minlength="6"
                                autocomplete="new-password" />
                            <button type="button" class="password-toggle" data-i18n-title="auth.show_password"
                                title="Показать пароль" aria-label="Показать пароль">👁</button>
                        </div>
                        <div class="password-field">
                            <input type="password" name="password2"
                                data-i18n-placeholder="profile.repeat_password_placeholder"
                                placeholder="Повторите новый пароль" required minlength="6"
                                autocomplete="new-password" />
                            <button type="button" class="password-toggle" data-i18n-title="auth.show_password"
                                title="Показать пароль" aria-label="Показать пароль">👁</button>
                        </div>
                        <div class="profile-form-actions">
                            <button type="submit" class="btn-primary" data-i18n="profile.save">Сохранить</button>
                            <span class="profile-status hidden" id="profile-password-status"></span>
                        </div>
                    </form>
                </div>

                <div class="card profile-card profile-game-card">
                    <h3 data-i18n="profile.game_profile_title">Игровой профиль</h3>
                    <p class="hint" data-i18n="profile.game_profile_hint">
                        Ваша карточка игрока с оценками, статистикой и историей игр.</p>
                    <a id="profile-game-link" class="btn-primary profile-game-link" href="/">
                        <span data-i18n="profile.game_profile_open">Открыть игровой профиль</span>
                    </a>
                    <p id="profile-game-unlinked" class="hint profile-game-unlinked hidden"
                        data-i18n="profile.game_profile_unlinked">
                        Игровой профиль ещё не привязан к аккаунту. Попросите модератора привязать его.</p>
                </div>
            </div>
        </section>

        <!-- ============================================ -->
        <!-- Секция: моя статистика -->
        <!-- ============================================ -->
        <section id="screen-my-stats" class="screen hidden">
            <button id="btn-back-my-stats" class="btn-secondary" data-i18n="player.back">← Назад</button>

            <div class="toolbar">
                <h2 id="my-stats-title" data-i18n="mystats.title">Моя статистика</h2>
                <div class="toolbar-actions">
                    <a id="my-stats-player-link" class="btn-secondary" href="/" data-i18n="mystats.open_card">Карточка игрока</a>
                </div>
            </div>

            <div id="my-stats-container">
                <div class="skeleton skeleton-block"></div>
            </div>
        </section>

        <!-- ============================================ -->
        <!-- Секция: все типажи -->
        <!-- ============================================ -->
        <section id="screen-archetypes" class="screen hidden">
            <button id="btn-back-archetypes" class="btn-secondary" data-i18n="player.back">← Назад</button>

            <div class="toolbar">
                <h2 data-i18n="archetypes.title">Все типажи</h2>
            </div>
            <p class="hint" data-i18n="archetypes.intro"></p>

            <div id="archetypes-container">
                <div class="skeleton skeleton-block"></div>
            </div>
        </section>

        <!-- ============================================ -->
        <!-- Секция: поддержка проекта -->
        <!-- ============================================ -->
        <section id="screen-support" class="screen hidden">
            <button id="btn-back-support" class="btn-secondary" data-i18n="support.back">← Назад</button>

            <div class="support-page">
                <div class="card support-hero">
                    <div class="support-hero-icon">💛</div>
                    <h2 data-i18n="support.page_title">Поддержать проект</h2>
                    <p data-i18n="support.page_intro">SC2 FFA League — некоммерческий проект. Я, nerdError, делаю его на чистом энтузиазме.</p>
                    <p class="support-hosting" data-i18n="support.page_hosting">Хостинг сайта стоит 550 ₽ в месяц.</p>
                </div>

                <h3 class="support-methods-title" data-i18n="support.methods_title">Способы поддержки</h3>

                <div class="support-methods">
                    <div class="card support-method">
                        <div class="support-method-icon">💳</div>
                        <h4 data-i18n="support.method_card_title">Перевод на карту (Сбер)</h4>
                        <p data-i18n="support.method_card_desc">Прямой перевод на карту Сбербанка.</p>
                        <div class="support-card-number">2202 2081 6733 1108</div>
                        <button type="button" id="support-copy-card" class="btn-primary"
                            data-i18n="support.method_card_copy">Скопировать номер карты</button>
                    </div>

                    <div class="card support-method">
                        <div class="support-method-icon">🌍</div>
                        <h4 data-i18n="support.method_da_title">DonationAlerts</h4>
                        <p data-i18n="support.method_da_desc">Сервис поддерживает иностранные платежи.</p>
                        <a class="btn-primary support-method-link" href="https://dalink.to/nerderror" target="_blank"
                            rel="noopener noreferrer" data-i18n="support.method_da_button">Открыть DonationAlerts</a>
                    </div>
                </div>

                <p class="support-thanks" data-i18n="support.thanks">Спасибо за любую поддержку!</p>

                <section class="support-donors" id="support-donors-section" hidden>
                    <h3 class="support-donors-title" data-i18n="support.donations_title">Спасибо тем, кто уже поддержал</h3>
                    <div id="support-donations" class="support-donations"></div>
                </section>
            </div>
        </section>
    </main>

    <footer class="site-footer">
        <div class="footer-line">
            <span data-i18n="footer.made_by">Made by</span> <span class="footer-author">nerdError</span>
            <span class="footer-year">2026</span>
        </div>
        <div class="footer-line">
            <span data-i18n="footer.inspired_by">Inspired by</span> <span class="footer-author2">Asfarion</span>
        </div>
        <div class="footer-support">
            <button type="button" id="btn-support" class="support-btn">
                <span class="support-icon">💛</span>
                <span class="support-label" data-i18n="support.button">Поддержать проект</span>
            </button>
        </div>
        <div class="footer-contacts">
            <a class="footer-link footer-link--telegram" href="https://t.me/nerderror404" target="_blank"
                rel="noopener noreferrer">
                Telegram: @nerderror404
            </a>
            <span class="footer-sep">·</span>
            <button type="button" class="footer-link footer-link--discord" id="copy-discord"
                data-i18n-title="footer.discord_copy" title="Скопировать тег">
                Discord: nerderror
            </button>
        </div>
    </footer>

    <!-- Модалка создания/редактирования игры -->
    <div id="game-modal" class="modal-overlay hidden">
        <div class="modal">
            <div class="modal-header">
                <h3 id="game-modal-title" data-i18n="games.form_title">Новая игра</h3>

                <label class="modal-use-last">
                    <input type="checkbox" id="field-use-last" checked />
                    <span data-i18n="games.use_last_game">Копировать предыдущие настройки</span>
                </label>

                <div class="modal-header-actions">
                    <button type="button" id="btn-clear-form" class="modal-clear" data-i18n="games.clear_form">
                        Очистить
                    </button>
                    <button type="button" class="modal-close" id="game-modal-close" aria-label="Close">✕</button>
                </div>
            </div>

            <form id="game-form" class="game-form">
                <div id="replay-completeness" class="replay-completeness hidden"></div>
                <div id="replay-duplicate" class="replay-duplicate hidden"></div>
                <label class="form-field">
                    <span data-i18n="games.field_date">Дата и время</span>
                    <div class="form-field-with-button">
                        <input type="datetime-local" name="played_at" id="field-played-at" required />
                        <button type="button" id="btn-now" class="form-add-btn form-add-btn--wide" data-i18n="games.now" title="Сейчас">Сейчас</button>
                        <button type="button" id="btn-add-5min" class="form-add-btn form-add-btn--wide"
                            title="+5 минут">+5</button>
                    </div>
                </label>
                <div class="form-row">
                    <label class="form-field">
                        <span data-i18n="games.field_format">Формат</span>
                        <select name="format_id" id="field-format" required></select>
                    </label>
                    <label class="form-field">
                        <span data-i18n="games.field_host">Проводящий</span>
                        <select name="host_id" id="field-host" required></select>
                    </label>
                </div>
                <div id="replay-host-hint" class="replay-host-hint hidden"></div>

                <div class="form-row">
                    <label class="form-field">
                        <span data-i18n="games.field_map">Карта</span>
                        <div class="form-field-with-button">
                            <div class="player-autocomplete map-combobox" id="map-combobox">
                                <input type="text" id="field-map-search" class="map-combobox-input"
                                    autocomplete="off"
                                    data-i18n-placeholder="games.map_search_placeholder"
                                    placeholder="Поиск карты…" />
                                <div id="map-combobox-dropdown" class="player-autocomplete-dropdown hidden"></div>
                            </div>
                            <button type="button" id="btn-edit-map" class="form-add-btn hidden"
                                data-i18n-title="games.edit_map" title="Редактировать карту">✎</button>
                            <button type="button" id="btn-add-map" class="form-add-btn"
                                title="Добавить карту">+</button>
                        </div>
                        <select name="map_id" id="field-map" class="hidden"></select>
                        <div id="field-map-warning" class="field-warning hidden"></div>
                    </label>
                    <label class="form-field">
                        <span data-i18n="games.field_mod">Мод</span>
                        <div class="form-field-with-button">
                            <select name="mod_id" id="field-mod"></select>
                            <button type="button" id="btn-add-mod" class="form-add-btn" title="Добавить мод">+</button>
                        </div>
                    </label>
                </div>
                <div id="replay-lobby-settings" class="replay-host-hint hidden"></div>

                <label class="form-field">
                    <span data-i18n="games.field_duration">Длительность (мин, опционально)</span>
                    <input type="number" name="duration_min" id="field-duration" min="1" max="999" />
                </label>

                <div class="form-section">
                    <div class="form-section-header">
                        <span data-i18n="games.field_players">Участники</span>
                        <div class="form-section-actions">
                            <button type="button" id="btn-create-player-inline" class="btn-icon-add"
                                title="Создать нового игрока в базе">
                                <span class="btn-icon-add-icon">+</span>
                                <span class="btn-icon-add-label" data-i18n="games.new_player">Новый</span>
                            </button>
                            <button type="button" id="btn-auto-places" class="btn-secondary"
                                data-i18n="games.auto_places" data-i18n-title="games.auto_places_hint"
                                title="Проставить места по порядку игроков в списке">
                                Расставить места
                            </button>
                            <button type="button" id="btn-add-player" class="btn-secondary"
                                data-i18n="games.add_player">
                                + Добавить игрока
                            </button>
                        </div>
                    </div>

                    <div class="form-toggles">
                        <label class="team-mode-toggle">
                            <input type="checkbox" id="field-is-team" />
                            <span data-i18n="games.is_team_label">Командная игра</span>
                        </label>

                        <div class="team-mode-options" id="team-mode-options" hidden>
                            <label class="form-field form-field--inline">
                                <span data-i18n="games.team_size_label">Размер команды</span>
                                <select id="field-team-size" class="games-filter-select">
                                    <option value="2">2v2</option>
                                    <option value="3">3v3</option>
                                    <option value="4">4v4</option>
                                </select>
                            </label>
                            <label class="form-field form-field--inline">
                                <span data-i18n="games.team_count_label">Количество команд</span>
                                <select id="field-team-count" class="games-filter-select">
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="8">8</option>
                                </select>
                            </label>
                        </div>
                    </div>

                    <p class="form-hint" data-i18n="games.players_hint">
                        Отметьте победителя. Остальным укажите место (2-е, 3-е, …) — места не должны повторяться.
                    </p>

                    <p class="form-hint form-hint--placement" id="players-placement-hint"></p>

                    <div id="players-list" class="players-list"></div>
                </div>

                <label class="form-field">
                    <span data-i18n="games.field_notes">Заметки (опционально)</span>
                    <textarea name="notes" id="field-notes" rows="3"></textarea>
                </label>

                <div class="form-actions">
                    <button type="button" id="btn-cancel-game" class="btn-secondary"
                        data-i18n="common.cancel">Отмена</button>
                    <button type="button" id="btn-delete-game" class="btn-danger btn-trash hidden"
                        data-i18n-title="common.delete" title="Удалить" aria-label="Удалить">🗑</button>
                    <button type="submit" id="btn-save-game" class="btn-primary"
                        data-i18n="common.save">Сохранить</button>
                </div>
            </form>
        </div>
    </div>

    <!-- Модалка добавления/редактирования карты -->
    <div id="map-modal" class="modal-overlay hidden">
        <div class="modal">
            <div class="modal-header">
                <h3 id="map-modal-title" data-i18n="maps.form_title">Новая карта</h3>
                <div class="modal-header-actions">
                    <button type="button" class="modal-close" id="map-modal-close" aria-label="Close">✕</button>
                </div>
            </div>

            <form id="map-form" class="game-form">
                <label class="form-field">
                    <span data-i18n="maps.field_name">Название</span>
                    <input type="text" id="map-field-name" required />
                </label>

                <label class="form-field">
                    <span data-i18n="maps.field_alt">Альт. название (локализация)</span>
                    <input type="text" id="map-field-alt" data-i18n-placeholder="admin.alt_name_placeholder"
                        placeholder="Альт. название" />
                </label>

                <div class="form-row">
                    <label class="form-field">
                        <span data-i18n="maps.field_players">Игроков</span>
                        <input type="number" id="map-field-players" min="1" max="64" />
                    </label>
                    <div class="form-field">
                        <span data-i18n="maps.field_types">Типы карты</span>
                        <div class="admin-ref-types" id="map-field-types"></div>
                    </div>
                </div>

                <!-- Формат командной карты: показываем только при типе «Командная» -->
                <div class="form-field hidden" id="map-formats-field">
                    <span data-i18n="maps.field_formats">Формат командных</span>
                    <div class="admin-ref-types" id="map-field-formats"></div>
                </div>

                <div class="form-row">
                    <label class="form-field">
                        <span data-i18n="maps.field_author">Автор</span>
                        <input type="text" id="map-field-author" data-i18n-placeholder="admin.map_author_placeholder"
                            placeholder="Автор" />
                    </label>
                    <label class="form-field">
                        <span data-i18n="maps.field_link">Ссылка</span>
                        <input type="text" id="map-field-link" data-i18n-placeholder="admin.map_link_placeholder"
                            placeholder="https://…" />
                        <span class="form-hint hidden" id="map-link-status"></span>
                    </label>
                </div>

                <!-- Пометка «дисбалансная»: карты с ней рандомайзер пропускает по умолчанию -->
                <label class="map-unbalanced-field">
                    <input type="checkbox" id="map-field-unbalanced" />
                    <span data-i18n="maps.field_unbalanced">Дисбалансная карта</span>
                </label>

                <div class="form-field">
                    <span data-i18n="maps.field_image">Картинка</span>
                    <div class="admin-map-image" id="map-field-image"></div>
                </div>

                <div class="form-actions">
                    <button type="button" id="btn-cancel-map" class="btn-secondary"
                        data-i18n="common.cancel">Отмена</button>
                    <button type="button" id="btn-delete-map" class="btn-danger btn-trash hidden"
                        data-i18n-title="common.delete" title="Удалить" aria-label="Удалить">🗑</button>
                    <button type="submit" id="btn-save-map" class="btn-primary"
                        data-i18n="common.save">Сохранить</button>
                </div>
            </form>
        </div>
    </div>

    <!-- Модалка добавления/редактирования мода -->
    <div id="mod-modal" class="modal-overlay hidden">
        <div class="modal">
            <div class="modal-header">
                <h3 id="mod-modal-title" data-i18n="mods.form_title">Новый мод</h3>
                <div class="modal-header-actions">
                    <!-- Индикатор автосохранения: правки уходят на сервер по мере ввода -->
                    <span id="mod-save-status" class="mod-save-status" aria-live="polite"></span>
                    <button type="button" class="modal-close" id="mod-modal-close" aria-label="Close">✕</button>
                </div>
            </div>

            <form id="mod-form" class="game-form">
                <p class="hint" data-i18n="mods.autosave_hint">Изменения сохраняются автоматически по мере ввода — отдельная кнопка «Сохранить» не нужна.</p>
                <div class="form-row">
                    <label class="form-field">
                        <span data-i18n="mods.field_name">Название</span>
                        <input type="text" id="mod-field-name" required />
                    </label>

                    <label class="form-field">
                        <span data-i18n="mods.field_author">Автор</span>
                        <input type="text" id="mod-field-author" data-i18n-placeholder="admin.map_author_placeholder"
                            placeholder="Автор" />
                    </label>
                </div>

                <label class="form-field">
                    <span data-i18n="mods.field_description">Описание</span>
                    <textarea id="mod-field-description" rows="3"
                        data-i18n-placeholder="mods.field_description_placeholder"
                        placeholder="Коротко о моде"></textarea>
                </label>

                <div class="form-field">
                    <div class="mod-settings-head">
                        <span data-i18n="mods.settings_title">Настройки</span>
                    </div>
                    <p class="hint" data-i18n="mods.settings_hint">Параметры пригодятся рандомизатору настроек мода.</p>
                    <div class="mod-settings-editor" id="mod-settings-editor"></div>
                </div>

                <div class="form-actions">
                    <button type="button" id="btn-delete-mod" class="btn-danger btn-trash hidden"
                        data-i18n-title="common.delete" title="Удалить" aria-label="Удалить">🗑</button>
                    <button type="button" id="btn-save-mod" class="btn-primary"
                        data-i18n="mods.done">Готово</button>
                </div>
            </form>
        </div>
    </div>

    <script type="module" src="/src/main.ts"></script>
</body>

</html>